import { IArticleResponse } from "../../../model/base/response/article-response";
import { IPortalCustomPageResponse } from "../../../model/base/response/portal-custom-page-response";

export type CustomPageState = {
    /** Artigo legado (link antigo "pagina-customizada/{idArtigo}"). */
    detail: IArticleResponse | undefined;
    /** Página customizada do APM (rota "/pagina/{slug}"). */
    page: IPortalCustomPageResponse | undefined;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setDetail = 'setDetail',
    setPage = 'setPage',
    setNotFound = 'setNotFound',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const CustomPageReducer = (state: CustomPageState, action: any): CustomPageState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setDetail:
            return {
                ...state,
                detail: payload,
                page: undefined,
                loading: false,
                error: null,
            };
        case ACTION_TYPES.setPage:
            return {
                ...state,
                page: payload,
                detail: undefined,
                loading: false,
                error: null,
            };
        case ACTION_TYPES.setNotFound:
            return {
                ...state,
                page: undefined,
                detail: undefined,
                loading: false,
                error: null,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
                error: null,
            };
        case ACTION_TYPES.setError:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
